"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAP_FILE_TYPE_TO_EXTENSION = void 0;
exports.MAP_FILE_TYPE_TO_EXTENSION = {
    pdf: 'application/pdf',
    jpeg: 'image/jpeg',
    jpg: 'image/jpg',
    png: 'image/png',
    gif: 'image/gif',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xls: 'application/vnd.ms-excel',
};
